
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-md-3">
         Patient Bills
        </div>
        <!--<div class="col-md-8 float-right padding-right-0px padding-l-0px display-inherit">
          <form novalidate="" #f="ngForm" class="display-inherit margin-left-auto">
           
            <div class="clear-form">
              <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
              <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
            </div>
            <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
          </form>
        </div>-->


        <div class="col-md-9 padding-left-0px float-right">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">


      <!--<div class="row margin-top-10 margin-bottom-10px margin-left-10px">
        <div class="col-md-5">
          <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">

        </div>



      </div>-->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero "
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>

                        <th class="min-width-24px">
                          
                        </th>


                        <th class="">
                          Bill Date
                        </th>
                        <th class="text-align-center padding-left-0px">
                          Bill No
                        </th>
                        <th>Bill Type</th>
                        <th>Branch</th>
                        <th class="text-align-center padding-right-0px">
                          Total Amount
                        </th>

                        <th class="text-align-center">
                          Paid
                        </th>
                        <th>Due</th>

                        <th class="padding-left-0px padding-right-0px">
                          Status
                        </th>






                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentBillDetailsInfoController ; let RowIndex = index ">


                        <td class="td-padding-tb">

                         
                          <button 
                                  type="button" class="btn font-size-13px actions-btn-prime" (click)="activeModal.close(l.ChargeEntry)">
                            Select
                          </button>
                        </td>
                        <td class=" td-padding-tb"><a (click)="Selectedpatient(l)" class="nav-link-hand"> {{l.BillCreatedDate | date:'MMM-dd-yyyy'}}</a></td>

                        <td class="text-align-center td-padding-tb padding-right-0px padding-left-8px"><a (click)="Selectedpatient(l)" class="nav-link-hand">{{l.BillNo}}</a></td>
                        <td class="td-padding-tb">{{l.BillType}}</td>
                        <td class="td-padding-tb ">{{l.BranchName}}</td>
                        <td class="td-padding-tb text-align-right padding-left-0px padding-right-15px">{{l.TotalAmount | number:'1.0-0' |removeComma}}</td>
                        <td class="td-padding-tb text-align-center">{{l.PaidTotal}}</td>
                        <td class="td-padding-tb text-align-center">{{l.Balance}}</td>
                        <td class=" td-padding-tb">

                          <a data-toggle="tooltip" data-placement="bottom" title="Fully Paid" *ngIf="l.BillStatus=='FP'">

                            <i class="fas fa-circle color-green  nav-link-hand font-size-14">
                            </i>
                          </a>
                          <a data-toggle="tooltip" data-placement="bottom" title="Partially Paid" *ngIf="l.BillStatus=='PP'">

                            <i class="fas fa-circle color-Assign  nav-link-hand font-size-14">
                            </i>
                          </a>
                          <a data-toggle="tooltip" data-placement="bottom" title="Not Paid" *ngIf="l.BillStatus=='NP'">

                            <i class="fas fa-circle color-gray  nav-link-hand font-size-14">
                            </i>
                          </a>
                        </td>



                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
    <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>-->

  </div>
</div>
